<template>
	<div class="modal-container modal-large">
		<div class="modal-header">Modify Deal</div>
		<div class="modal-body">
			<div class="TestModelEditor">
				<JsonEditorVue
					v-model="fimenu"
					@input="() => (isJsonEdited = true)"
				/>
			</div>
		</div>

		<div class="modal-footer">
			<button
				@click="close"
				class="button-unwind"
			>
				Cancel
			</button>
			<button
				@click="save"
				class="button-save"
			>
				Apply
			</button>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { ref } from 'vue';
	import $modal from '@core/services/modal';
	import JsonEditorVue from 'json-editor-vue';

	interface Props {
		modal: {
			passedData: {
				fimenu: any;
			};
		};
	}

	const props = defineProps<Props>();
	const fimenu = ref(JSON.parse(JSON.stringify(props.modal.passedData.fimenu)));
	const isJsonEdited = ref(false);

	const close = () => {
		$modal.cancel();
	};
	const save = () => {
		$modal.close(fimenu.value);
	};
</script>

<style scoped>
	.TestModelEditor {
		height: 100%;
		width: 100%;
		max-width: unset;
	}
</style>
